export default {
    LOCALSTORAGE: {
        BEARER_TOKEN: 'token',
        BEARER_TOKEN_EXPIRATION: 'tokenExp',
        GIFT_DATA: 'giftData',
        GENERAL_PLAYER_CARD_SHOW_ALWAYS_ALL_DETAILS: 'generalPlayerCardShowAlwaysAllDetails',
        OFFER_THRESHOLD: 'offerThreshold',
        OFFER_ORDER: 'offerOrder',
        OFFER_SHOW_TOO_LOW_OFFERS_ONLY: 'offerShowTooLowOffersOnly',
        OFFER_PANEL_PLAYER_NOT_ON_MARKET: 'offerPanelOpenPlayerNotOnMarket',
        OFFER_PANEL_PLAYER_WITHOUT_ANY_OFFER: 'offerPanelOpenPlayerWithoutAnyOffer',
        TRANSFER_MARKET_EXPIRY_DATE_FADE_EFFECT: 'transfermarketExpiryDateFadeEffect',
        TRANSFER_MARKET_EXPIRY_DISPLAY_TYPE: 'transfermarketExpiryDisplayType',
    }
}